import React, { createContext, useContext, useState, useEffect } from 'react'
import enTranslations from '../locales/en.json'
import nlTranslations from '../locales/nl.json'

type Locale = 'en' | 'nl'

interface LocaleContextType {
  locale: Locale
  setLocale: (locale: Locale) => void
  t: (key: string) => string
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined)

export const useLocale = () => {
  const context = useContext(LocaleContext)
  if (context === undefined) {
    throw new Error('useLocale must be used within a LocaleProvider')
  }
  return context
}

interface LocaleProviderProps {
  children: React.ReactNode
}

export const LocaleProvider: React.FC<LocaleProviderProps> = ({ children }) => {
  const [locale, setLocale] = useState<Locale>('nl') // Default to Dutch
  const [translations, setTranslations] = useState<Record<string, any>>({})

  useEffect(() => {
    // Load translations directly from imported JSON files
    const translationMap = {
      en: enTranslations,
      nl: nlTranslations
    }
    
    setTranslations(translationMap[locale])
  }, [locale])

  const t = (key: string): string => {
    const keys = key.split('.')
    let value: any = translations

    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k]
      } else {
        // Return the key if translation not found
        return key
      }
    }

    return typeof value === 'string' ? value : key
  }

  const value = {
    locale,
    setLocale,
    t
  }

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
}


